import i18n from '@i18next/i18n';
import type { FontList } from './index';

export const fontListIPad: FontList = [
    i18n.t('默认字体'),
    ['Microsoft YaHei', i18n.t('雅黑')],
    'Times New Roman',
    'Courier New',
    'Futrua',
    'Papyrus',
    'Rockwell',
    'Trebuchet MS',
    'Verdana',
];
